<div *ngIf="order" class="layout-column tr fade-element-in-only" [ngClass]="{'selected': isSelected}">

  <div class="flex layout-row layout-align-start-center">
    <div class="td sticky large flex-10 layout-row layout-align-start-center">

      <app-oms-order-action-menu *ngIf="order.status !== 'Canceled'"
                                 [order]="order"
                                 [canRecover]="canRecover"
                                 [deliverySchedulingStateReference]="order.deliverySchedulingStateReference"
                                 (onSendToDispatch)="onSendToDispatch.emit($event)"
                                 (onAddNote)="onAddNote.emit($event)"
                                 (onSetOrderOnHold)="onSetOrderOnHold.emit($event)"
                                 (onResumeOrder)="onResumeOrder.emit($event)"
                                 (onManuallyCompleteOrder)="onManuallyCompleteOrder.emit($event)"
                                 (onEdit)="onEdit.emit($event)"
                                 (onDuplicate)="onDuplicate.emit($event)"
                                 (onPrintBillOfLading)="onPrintBillOfLading.emit($event)"
                                 (onDownloadBillOfLading)="onDownloadBillOfLading.emit($event)"
                                 (onSendSchedulingSMSClicked)="onSendSchedulingSMSClicked.emit($event)"
                                 (onSendSchedulingWhatsappClicked)="onSendSchedulingWhatsappClicked.emit($event)"
                                 (onViewSchedulingLink)="onViewSchedulingLink.emit()"
                                 (onRecover)="onRecover.emit($event)"
                                 (onCancelOrder)="onCancelOrder.emit($event)">
      </app-oms-order-action-menu>

      <div *ngIf="order.status === 'Canceled'" flex="5"></div>

      <app-bringoz-checkbox [isChecked]="isSelected"
                            (clickEvent)="onToggleSelect.emit(order);$event.stopPropagation()">
      </app-bringoz-checkbox>

      <div class="layout-column margin-left-5">

        <div class="layout-row layout-align-start-start">

          <div class="layout-row text-ellipsis">

            <div class="flex layout-column text-ellipsis full-height">

              <div class="layout-row layout-align-start-start">


                <div class="layout-row layout-align-start-start"
                     (mouseenter)="canCopyOrderId = true"
                     (mouseleave)="canCopyOrderId = false">
                  <app-bringoz-state-link class="text-ellipsis"
                                          [permission]="'oms.orders.get'"
                                          [state]="'order.info'"
                                          [params]="{id: order.id}"
                                          [text]="order.id">
                  </app-bringoz-state-link>

                  <app-text-copy-button *ngIf="canCopyOrderId"
                                        [text]="order.id"
                                        [isShowCopyBtn]="true"></app-text-copy-button>
                </div>

                <app-activity-packed-indication *ngIf="order.itemLines"
                                                class="margin-right-5 margin-left-5"
                                                [isPacked]="order.packed"
                                                [packages]="order.itemLines"
                                                [stopType]="order.status">

                </app-activity-packed-indication>


                <bringoz-icon
                  *ngIf="order.fulfillmentLines[0].pickupTask?.obligateTimeWindow || order.fulfillmentLines[0].destinationTask?.obligateTimeWindow"
                  iconName="obligate" class="gray-102 margin-left-5" [ngbTooltip]="'Guarantee' | translate"
                  openDelay="300"
                  container="body"
                  triggers="hover">
                </bringoz-icon>

                <bringoz-icon
                  *ngIf="order.fulfillmentLines[0].pickupTask?.schedulingRequired || order.fulfillmentLines[0].destinationTask?.schedulingRequired"
                  iconName="schedule-call" class="md-warn margin-left-5"
                  [ngClass]="{'green': order.status === 'Completed' || order.status === 'Scheduled'}"
                  [ngbTooltip]="'Schedule required' | translate" openDelay="300"
                  container="body"
                  triggers="hover">
                </bringoz-icon>

              </div>


              <div *ngIf="order.externalId" class="layout-row layout-align-start-start"
                   (mouseenter)="canCopyOrderExternalId = true"
                   (mouseleave)="canCopyOrderExternalId = false">
                <app-bringoz-state-link class="text-ellipsis"
                                        [permission]="'oms.orders.get'"
                                        [state]="'order.info'"
                                        [params]="{id: order.id}"
                                        [text]="order.externalId">
                </app-bringoz-state-link>

                <app-text-copy-button *ngIf="canCopyOrderExternalId"
                                      [text]="order.externalId"
                                      [isShowCopyBtn]="true"></app-text-copy-button>
              </div>
            </div>

          </div>

        </div>

        <app-bringoz-status-tag [status]="order.status" [entity]="'order'"
                                class="margin-top-5"></app-bringoz-status-tag>

      </div>

    </div>

    <!--Account-->
    <div class="td large flex layout-column gap-5" *ngIf="columns.account?.enabled">

      <div class="layout-row layout-align-start-center"
           (mouseenter)="canCopyAccount = true; canFilterByAccount = true"
           (mouseleave)="canCopyAccount = false; canFilterByAccount = false">
        <app-bringoz-state-link class="text-ellipsis"
                                [permission]="'accounts.demand.get'"
                                [state]="'accounts-detail-demand.info.preferences'"
                                [params]="{id: order.accountReference.id}"
                                [text]="order.accountReference.name">
        </app-bringoz-state-link>

        <app-text-copy-button *ngIf="canCopyAccount" [text]="order.accountReference.id"
                              [isShowCopyBtn]="true">

        </app-text-copy-button>

        <bringoz-button *ngIf="canFilterByAccount"
                        (onClick)="onFilterByType.emit({type: siteFiltersType.accountIds, value: order.accountReference.id}); $event.stopPropagation();"
                        type="tertiary">
          <bringoz-icon iconName="filter" class="gray-102"></bringoz-icon>
        </bringoz-button>
      </div>

      <div class="layout-row layout-align-start-center">
        <app-bringoz-tags [tags]="order.accountReference.tags" maxTags="2"></app-bringoz-tags>
      </div>

    </div>


    <!--Account External ID-->
    <div class="td large flex layout-column gap-5" *ngIf="columns.accountExternalId?.enabled">
      <span class="br-body-2">{{order.accountReference?.externalId}}</span>
    </div>

    <!--Branches-->
    <div class="td large flex layout-column gap-5" *ngIf="columns.branches?.enabled">
      <branches-indicator [branches]="order.branchReferences"></branches-indicator>
    </div>

    <!--Contact/Phone/Locations-->
    <div class="layout-column">

      <app-oms-orders-table-row-task [task]="order.fulfillmentLines[0].pickupTask"
                                     [columns]="columns">

      </app-oms-orders-table-row-task>


      <app-oms-orders-table-row-task [task]="order.fulfillmentLines[0].destinationTask"
                                     [columns]="columns">

      </app-oms-orders-table-row-task>

    </div>

    <!--Relations-->
    <div class="td small text-ellipsis flex layout-column"
         *ngIf="columns.relations?.enabled">
      <div *ngIf="order.blockedByOrders?.length" class="flex layout-column gap-5">

        <div class="layout-row layout-align-start-center">
          <span class="br-body-2" translate>BlockedBy</span>
        </div>

        <div class="layout-column layout-align-center-start gap-5">
          <app-oms-order-link *ngFor="let blockedOrder of order.blockedByOrders"
                              [internalId]="blockedOrder?.omsOrderId"
                              [externalId]="blockedOrder?.externalId">
          </app-oms-order-link>
        </div>

      </div>
    </div>

    <!--Program-->
    <div class="td small text-ellipsis flex layout-column layout-align-center-start"
         *ngIf="columns.programType?.enabled">
      <div class="layout-row layout-align-start-center" *ngFor="let fulfillmentLine of order.fulfillmentLines">
        <span class="br-body-2">{{ fulfillmentLine.programName }}</span>
        <span class="br-body-2" *ngIf="fulfillmentLine.programName && fulfillmentLine.programType"> / </span>
        <span class="br-body-2">{{ fulfillmentLine.programType }}</span>
      </div>
    </div>

    <!--SLA-->
    <div class="td small flex-5 layout-row layout-align-start-center" *ngIf="columns.sla?.enabled">
      <span class="br-body-2 text-ellipsis">
        {{ order | bringozFullDate: 'dueTo' }} {{ order | bringozTime: 'dueTo' }}
      </span>
    </div>

    <!--Time To Deliver-->
    <div class="td small flex-5 layout-row layout-align-start-center" *ngIf="columns.timeToDeliver?.enabled">
      <span *ngIf="order.dueTo" class="br-body-2 text-ellipsis">{{ order.dueTo | bringozTimeAgo }}</span>
      <span *ngIf="!order.dueTo" class="br-body-2">---</span>
    </div>

    <div class="td small br-body-2 flex-10 layout-row layout-align-start-center"
         *ngIf="columns.fulfillmentStatus?.enabled">
      <app-bringoz-status-tag [status]="order.fulfillmentLines[0].displayStatus"></app-bringoz-status-tag>
    </div>

    <!--Reference ids-->
    <div class="td small flex-5 layout-column layout-align-center-start"
         *ngIf="columns.referenceIds?.enabled">
      <app-bringoz-items-list-display [items]="order.referenceIds" [maxItems]="1"></app-bringoz-items-list-display>
    </div>

    <!--Created Time-->
    <div class="td small flex-5 layout-column layout-align-center-start" *ngIf="columns.createdAt?.enabled">
      <span class="br-body-2 text-ellipsis">{{ order | bringozTime: 'createdAt' }}</span>
      <span class="br-body-2 text-ellipsis">{{ order | bringozFullDate: 'createdAt' }}</span>
    </div>

    <!--PRO Number-->
    <div class="td small flex layout-row" *ngIf="columns.proNumber?.enabled"
         ng-mouseenter="canCopyProNumber=true"
         ng-mouseleave="canCopyProNumber=false">

      <span [ngbTooltip]="order.fulfillmentLines[0].proNumber ? order.fulfillmentLines[0].proNumber: null"
            openDelay="300"
            container="body"
            triggers="hover">{{ order.fulfillmentLines[0].proNumber || '---' }}</span>

      <app-text-copy-button *ngIf="canCopyProNumber" [text]="order.fulfillmentLines[0].proNumber"
                            [isShowCopyBtn]="true"></app-text-copy-button>

    </div>

    <!--SCHEDULING SMS-->
    <div class="td medium flex layout-column" *ngIf="columns.schedulingSms?.enabled">
      <div class="br-body-2 flex layout-column" *ngIf="order.deliverySchedulingStateReference">
        <span
          class="text-ellipsis">{{ 'SCHEDULING_SMS.' + order.deliverySchedulingStateReference.status | translate }}</span>
        <div>
          <span *ngIf="order.deliverySchedulingStateReference.numSmsSent" class="margin-right-5">
            {{ 'Sms Sent On' | translate }}</span>
          <span *ngIf="order.deliverySchedulingStateReference.numWhatsAppSent" class="margin-right-5">
            {{ 'WhatsApp Sent On' | translate }}</span>
          <span *ngIf="order.deliverySchedulingStateReference.lastSmsSentTimestamp"
            class="margin-right-5">{{ order.deliverySchedulingStateReference | bringozFullDate:'lastSmsSentTimestamp' }}</span>
          <span *ngIf="order.deliverySchedulingStateReference.lastWhatsAppSentTimestamp"
                class="margin-right-5">{{ order.deliverySchedulingStateReference | bringozFullDate:'lastWhatsAppSentTimestamp' }}</span>
          <span *ngIf="order.deliverySchedulingStateReference.numSmsSent"
            class="margin-right-5">({{
              order.deliverySchedulingStateReference.numSmsSent === 1 ? ('X_TIME' | translate) : 'X_TIMES' | translate:{num: order.deliverySchedulingStateReference.numSmsSent || 0}
            }})</span>
          <span *ngIf="order.deliverySchedulingStateReference.numWhatsAppSent"
                class="margin-right-5">({{
              order.deliverySchedulingStateReference.numWhatsAppSent === 1 ? ('X_TIME' | translate) : 'X_TIMES' | translate:{num: order.deliverySchedulingStateReference.numWhatsAppSent || 0}
            }})</span>
        </div>
      </div>
    </div>


    <!--Billing order-->
    <div class="td small flex" *ngIf="columns.billingOrder?.enabled">
      <span
        *ngIf="!!order.billingOrderReference?.totalPrice">{{ order.billingOrderReference?.totalPrice | bringozPrice }}</span>
    </div>

    <!--Items Ids-->
    <div class="td small flex" *ngIf="columns.itemsIds?.enabled">
      <app-bringoz-packages-items-display-list [isDisplayIds]="true"
                                               [items]="order.itemLines"></app-bringoz-packages-items-display-list>
    </div>

    <!--Items Types-->
    <div class="td small flex" *ngIf="columns.itemsTypes?.enabled">

      <app-packages-indicator [packages]="order.itemLines"
                              [isShowFilterByButton]="true"
                              (onFilterByType)="onFilterByType.emit({type: $event.type, value: $event.value})"
                              [maxDisplay]="1">
      </app-packages-indicator>

    </div>

    <!--Items Barcodes-->
    <div class="td small flex" *ngIf="columns.itemsBarcodes?.enabled">
      <app-bringoz-items-list-display [items]="order.itemBarcodes"
                                      [maxItems]="1"
                                      [canCopy]="true">

      </app-bringoz-items-list-display>
    </div>


    <!--Pallets-->
    <div class="td small flex" *ngIf="columns.pallets?.enabled">
      <span class="br-body-2">{{order.itemLines | orderPallets:true}}</span>
    </div>

    <!--Notes-->
    <div class="td large padding-0 flex-10 layout-column" *ngIf="columns.notes?.enabled">
      <app-oms-orders-fulfillment-line-notes class="text-ellipsis"
                                             [order]="order">

      </app-oms-orders-fulfillment-line-notes>
    </div>

    <!--Dynamic Columns-->
    <div class="td small layout-row flex"
         *ngFor="let metaData of enabledDynamicColumns">
      <span class="br-body-2 text-ellipsis">{{ order.metaData | bringozMetaDataDisplay: metaData }}</span>
    </div>

    <!--Packages Dynamic Columns-->
    <div class="td small text-ellipsis flex layout-row"
         *ngFor="let packageDynamicColumns of enabledPackageDynamicColumns">
      <span
        class="br-body-2 text-ellipsis">{{ order.itemLines | bringozPackagesCustomDataDisplay: packageDynamicColumns }}</span>
    </div>


  </div>

</div>
